<template>
    <NuxtPage/>
</template>

<script setup lang="ts">
import {useSectionStore} from "../../store/section";

const sectionStore = useSectionStore();
const {params} = useRoute();

await sectionStore.loadSection(params.area, params.section);
</script>

